import { useState } from "react";
import { useFormatTemplateStore } from "@/state/formatTemplateStore";

export const FormatTemplateSidePanel = () => {
  const { formatTemplateSidebar, setFormatTemplateSidebar } = useFormatTemplateStore();
  const [isDropdownOpen, setIsDropdownOpen] = useState(true);

  return (
    <div
      className={"border-r-2 border-gray-200"}
      style={{
        width: "20%",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        padding: "1rem",
        color: "white",
        boxSizing: "border-box",
        backgroundColor: "#002945",
      }}
    >

      <img src="assets/AlphaScript-logo.png" alt="" className="w-36 h-auto object-contain mb-8" />

      <ul style={{ listStyle: "none", padding: 0 }}>
        {/* Format Template Main Category */}
        <li
          style={{
            marginBottom: "0.5rem",
            marginLeft: "0.5rem",
            cursor: "pointer",
            color:
              formatTemplateSidebar === "format-template" ||
              formatTemplateSidebar === "search-existing" ||
              formatTemplateSidebar === "create-new" ||
              formatTemplateSidebar === "update"
                ? "#FF5C35"
                : "#ffffff",
          }}
          onClick={() => {
            setFormatTemplateSidebar("format-template");
            setIsDropdownOpen(!isDropdownOpen); // Toggle dropdown on click of main category
          }}
        >
          Format Template
        </li>

        {/* Dropdown for "Format Template" */}
        {isDropdownOpen && (
          <ul style={{ paddingLeft: "1rem", marginTop: "0.5rem" }}>
            <li
              style={{
                marginBottom: "0.5rem",
                cursor: "pointer",
                color: formatTemplateSidebar === "search-existing" ? "#ff5c35" : "#ffffff",
              }}
              onClick={() => setFormatTemplateSidebar("search-existing")}
            >
              Search Existing
            </li>
            <li
              style={{
                marginBottom: "0.5rem",
                cursor: "pointer",
                color: formatTemplateSidebar === "create-new" ? "#ff5c35" : "#ffffff",
              }}
              onClick={() => setFormatTemplateSidebar("create-new")}
            >
              Create New
            </li>
          </ul>
        )}

        {/* Other Menu Item */}
        <li
          style={{
            marginBottom: "0.5rem",
            marginLeft: "0.5rem",
            cursor: "pointer",
            color: formatTemplateSidebar === "account-management" ? "#ff5c35" : "#ffffff",
          }}
          onClick={() => {
            setFormatTemplateSidebar("account-management");
            setIsDropdownOpen(false);
          }}
        >
          Account Management
        </li>
      </ul>
    </div>
  );
};
